import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { setReportCreditFilters, getReportCreditAction } from "redux/actions/Reports/reportCredit/reportCreditActions";

export const ReportCreditView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportCredit }) => reportCredit);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getReportCreditAction({startDate, endDate, station, isPdf}))
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte de Crédito" icon={<AssessmentIcon />} >
      <TableInputs
        reducer="reportCredit"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportCreditFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingReportCredit}
      />
      {isLoadingComp?.loadingReportCredit && <LoadingComponent />}
    </GlobalBox>
  );
};
